/**
 * Whether the signed-in person's company may use the system. The server answers 403 with errors.code "tenant_inactive"
 * when it may not (suspended, closed, or still being set up), and the message carries the staff's reason.
 */
import { create } from 'zustand'
import { useAuthStore } from '@store/authStore'

/** The server's plain-words reason when a response says the company is not active, otherwise null. */
export function tenantInactiveMessage(err: unknown): string | null {
  const r = (err as { response?: { status?: number; data?: { message?: unknown; errors?: { code?: unknown } } } })?.response
  if (r?.status !== 403 || r.data?.errors?.code !== 'tenant_inactive') return null
  return typeof r.data.message === 'string' && r.data.message.trim() ? r.data.message.trim() : ''
}

interface AccessState { inactive: string | null; setInactive: (m: string | null) => void }

/** Not persisted: a reload asks the server again. */
export const useTenantAccess = create<AccessState>((set) => ({
  inactive: null,
  setInactive: (inactive) => set({ inactive }),
}))

// Signing out, or in as someone else, starts clean.
useAuthStore.subscribe((s, p) => {
  if (s.user?.id !== p.user?.id) useTenantAccess.getState().setInactive(null)
})
